import React, { useEffect, useState } from "react";
import { useAdjustedInventoryQuery } from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";


const InventoryAdjustment = () => {
    const [adjustedInventoryData, setAdjustedInventoryData] = useState([]);

    const { data: adjustedInventory, isLoading } = useAdjustedInventoryQuery({});

    useEffect(() => {
        if (adjustedInventory) {
            setAdjustedInventoryData(adjustedInventory?.adjustments);
        }
    }, [adjustedInventory]);



    const header = [
        { label: "Sr.No.", key: "Sr.no" },
        { label: "Part number", key: "part_number" },
        { label: "Stock in Qty", key: "stockInqty" },
        { label: "Stock out Qty", key: "stockOutQty" },
        { label: "Remarks", key: "remarks" },
    ];

        const {
            selectedColor,
            selectedBackgroundColor,
            selectedBorderColor,
            selectedButtonBackgoundColors,
            selectedButtonColors,
        } = useThemeColors();
    
    return (
            <div className="vehicle-info-cont">

            <div
                className="vehicle-info-bottom"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
            >
                <div className="vehicle-info-bottom-heading">Inventory Adjustment</div>
                <table className="vehicle-info-bottom-table">
                    <thead
                        className="thead"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px 15px",
                        }}
                    >
                        {header?.map((card, index) => (
                            <tr className="tr" style={{ padding: "5px 25px" }}>
                                <td >{card?.label}</td>
                            </tr>
                        ))}
                        {/* <div style={{ width: "10%" }}>
                            <label
                                htmlFor=""
                                // style={{ paddingRight: "25px" }}
                            >
                                <strong>Action</strong>
                            </label>
                        </div> */}
                    </thead>
                    <tbody className="table-body">
                        {adjustedInventoryData?.map((vehicle, index) => (
                            <tr
                                className="table-body-tr"
                                style={{
                                    background:
                                        index % 2 !== 0 ? "#FFF1EC" : "white",
                                        width: "100%"
                                }}
                            >
                                <td style={{width :"20%"}}>{index + 1}</td>
                                <td style={{width :"20%", paddingLeft: "30px"}}>{vehicle?.part_number}</td>
                                <td style={{width :"20%", display: "flex", justifyContent: "center"}}>{vehicle?.stock_in}</td>
                                <td style={{width :"20%", display: "flex", justifyContent: "center", paddingLeft: "70px"}}>{vehicle?.stock_out}</td>
                                <td style={{width: "20%", display: "flex", justifyContent: "end"}}>{vehicle?.remarks}</td>

                            
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


      
        </div>
    );
};

export default InventoryAdjustment;
